import { render } from "./Footer.html?vue&type=template&id=495d0582&scoped=true&ts=true&external"
import script from "./Footer.ts?vue&type=script&lang=ts&external"
export * from "./Footer.ts?vue&type=script&lang=ts&external"

import "./Footer.scss?vue&type=style&index=0&id=495d0582&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495d0582"]])

export default __exports__